// extracted by mini-css-extract-plugin
module.exports = {"layout":"styles_layout__2aTIJ","main":"styles_main__vq2PA","side":"styles_side__cqInu","sticky":"styles_sticky__2SUX9"};